import { AboutContainer, Title, Paragraph, MiniTitle } from '../styled';
import { VisionMissionBox, VisionContainer, VisionImage, VisMisBox, VisionImageContainer } from './styled';

const Vision = () => (
  <AboutContainer>
    <Title align="center" mb="50px">Visi & Misi Perusahaan</Title>
    <VisionContainer align="center">
      <VisionMissionBox>
        <VisionImageContainer>
          <VisionImage src="/images/vision.svg" />
        </VisionImageContainer>
        <VisMisBox>
          <MiniTitle>Visi Perusahaan</MiniTitle>
          <Paragraph>
            Visi kami adalah menjadi penasihat, perantara, dan rekanan yang
            terpercaya untuk membantu nasabah dalam menentukan strategi finansial
            di pasar modal indonesia. Stockbit Sekuritas Digital berkomitmen untuk
            memberikan layanan yang handal dan konsisten untuk kepentingan
            nasabah.
          </Paragraph>
        </VisMisBox>
      </VisionMissionBox>
    </VisionContainer>
    <VisionContainer>
    <VisionMissionBox>
        <VisionImageContainer>
          <VisionImage src="/images/mission.svg" />
        </VisionImageContainer>
        <VisMisBox>
          <MiniTitle>Misi Perusahaan</MiniTitle>
          <Paragraph>
            Misi kami adalah untuk menyediakan sarana investasi pasar modal yang mudah, aman dan nyaman untuk pemula. Selain itu, Misi penting kami juga terbagi dalam 3 hal utama, yaitu:
            <ul>
              <li>Meningkatkan literasi keuangan dengan meningkatkan edukasi dan kesadaran berinvestasi</li>
              <li>Berkontribusi dalam suatu sistem pasar modal yang bekerja dengan baik dan inklusif</li>
              <li>Berkontribusi untuk memperdalam pasar modal sehingga memperkuat platform penggalangan dana untuk perusahaan Indonesia</li>
            </ul>
          </Paragraph>
        </VisMisBox>
      </VisionMissionBox>
      
    </VisionContainer>
  </AboutContainer>
);

export default Vision;
